class Accordion {
    // [parentsClass] ドット無しのクラス名　例： .class 
    // [openerClass] ドット無しのクラス名　例： .class 
    // [panelClass] ドット無しのクラス名　例： .class 
    // [panelClass] ドット無しのクラス名　例： class 
    //　[spOnly] スマホのみの処理の場合は trueにする
    //　[pcOnly] スマホのみの処理の場合は trueにする

    constructor({parent, opener, panel, activating = 'is-open', spOnly = false, pcOnly = false, isResetable = true} ) {
        this.responsive = {
            spOnly,
            pcOnly
        }
        this.isResetable = isResetable;

        this.classes = {
            parent,
            opener,
            panel,
            activating,
            nextActiveTab: 'next-active-tab',
            prevActiveTab: 'prev-active-tab'
        }

        this.parents = document.querySelectorAll(`.${this.classes.parent}`);
        this.parents.forEach(parent => {
            this.opener = parent.querySelector(`.${this.classes.opener}`);
            this.panel = parent.querySelector(`.${this.classes.panel}`);

            // クラス名がパネルがない要素にもあるから、
            // 処理はパネルがある要素のみに処理
            if(this.panel) {
                this.events();
            }

        })
    }

    // ============
    // Events
    // =============
    events() {
        this.handleBeforeAfter();
        // アコーディオンの処理
        this.opener.addEventListener("click", (event) => this.clickHandler(event.target, event.target.nextElementSibling ));

        // スマホのみ/パソコンのみの処理の場合、
        // そうでないサイズの際に処理をリセット
        window.addEventListener('resize', () => {
            if(this.responsive.spOnly) {
                if(matchMedia("(min-width: 992px)").matches) {
                    this.resetAll();
                }
            }

            if(this.responsive.pcOnly) {
                if(matchMedia("(max-width: 992px)").matches) {
                    this.resetAll();
                }
            }

        })
    }

    clickHandler(opener, panel) {
        if(this.responsive.spOnly) {
            if(matchMedia("(max-width: 992px)").matches) {
                this.toggle(opener, panel);
                this.resetBeforeAfter();
                this.handleBeforeAfter();
            }
        }else if (this.responsive.pcOnly) {
            if(matchMedia("(min-width: 992px)").matches) {
                this.toggle(opener, panel);
                this.resetBeforeAfter();
                this.handleBeforeAfter();
            }
        }else {
            this.toggle(opener, panel);
            this.resetBeforeAfter();
            this.handleBeforeAfter();
        }
    }

    // ============
    // Methods
    // =============

    // パネルの開きと閉じ
    toggle(opener, panel) {
        if(panel.classList.contains(this.classes.panel)) {
            // 対処ではない要素をリセット
            this.reset(opener, panel);

            // 対処の要素の開く処理を行う
            if(this.isResetable) {
                opener.classList.toggle(this.classes.activating);
            }else {
                opener.classList.add(this.classes.activating);
            }

            if(opener.classList.contains(this.classes.activating)) {
                panel.style.maxHeight = 'unset';
            }else {
                panel.style = '';
            }
        }
    }

    // アクティブなアコーディオンの前後にある要素に
    // そのアコーディオンからの位置を特定するクラスを追加するメソッド
    handleBeforeAfter() {
        if(this.parents) {
            this.parents.forEach(parent => {
                if(
                    parent && 
                    parent.querySelector(`.${this.classes.opener}`).classList.contains(this.classes.activating)
                ) {
                    const nextElement = parent.nextElementSibling;
                    const prevElement = parent.previousElementSibling;

                    if(nextElement && nextElement.classList.contains(this.classes.parent)) {
                        nextElement.classList.add(this.classes.nextActiveTab);
                    }

                    if(prevElement && prevElement.classList.contains(this.classes.parent)) {
                        prevElement.classList.add(this.classes.prevActiveTab);
                    }
                }
            });
        }
    }

    // 新規クリックの際に「handleBeforeAfter」のメソッドをリセットするメソッド
    resetBeforeAfter() {
        if(this.parents) {
            this.parents.forEach(parent => {
                if(parent) {
                    if(!parent.classList.contains(this.classes.activating) ) {
                        const prevElement = parent.previousElementSibling;
                        const nextElement = parent.nextElementSibling;

                        if(
                            prevElement &&
                            prevElement.previousElementSibling && 
                            prevElement.previousElementSibling.classList.contains(this.classes.parent) &&
                            !prevElement.previousElementSibling.classList.contains(this.classes.activatingClass) 
                        ) {
                            if(parent.classList.contains(this.classes.prevActiveTab)) {
                                parent.classList.remove(this.classes.prevActiveTab)
                            }
                            if(parent.classList.contains(this.classes.nextActiveTab)) {
                                parent.classList.remove(this.classes.nextActiveTab)
                            }

                        }
                        
                        if(
                            nextElement &&
                            nextElement.nextElementSibling && 
                            nextElement.nextElementSibling.classList.contains(this.classes.parent) &&
                            !nextElement.nextElementSibling.classList.contains(this.classes.activatingClass)
                        ) {
                            if(parent.classList.contains(this.classes.prevActiveTab)) {
                                parent.classList.remove(this.classes.prevActiveTab)
                            }
                            if(parent.classList.contains(this.classes.nextActiveTab)) {
                                parent.classList.remove(this.classes.nextActiveTab)
                            }
                        }
                        

                    }

                }

            });
        }
    }

    // 対象パネル以外のパネルのリセット
    reset(opener, panel) {
        this.parents.forEach(parent => {
            if(parent.querySelector(`.${this.classes.opener}`) !== opener) {
                parent.querySelector(`.${this.classes.opener}`).classList.remove(this.classes.activating);
            }

            if(parent.querySelector(`.${this.classes.panel}`) && 
                parent.querySelector(`.${this.classes.panel}`) !== panel
            ) {
                parent.querySelector(`.${this.classes.panel}`).style = '';
            }
        });
    }

    // 全てのリセット
    resetAll() {
        this.parents.forEach(parent => {
            if(parent.querySelector(`.${this.classes.opener}`)) {
                parent.querySelector(`.${this.classes.opener}`).classList.remove(this.classes.activating);
            }

            if(parent.querySelector(`.${this.classes.panel}`)) {
                parent.querySelector(`.${this.classes.panel}`).style = '';
            }
        })
    }
}

export default Accordion;